import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { EnumLoginStatus, EnumUserStatus, UserBadLoginAttempt } from '../../../globals';
import { getEnumValue } from '../../enum-helper';

@Component({
  selector: 'ez-login-errors',
  imports: [
    MatIconModule,
  ],
  templateUrl: './login-errors.component.html',
  styleUrls: ['./login-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginErrorsComponent {
  badLogInAttempt = input.required<UserBadLoginAttempt>();
  forgotPasswordUrl = input.required<string>();
  isAutomationUser = input.required<boolean>();
  legacyLoginUrl = input.required<string>();

  ssoClientName: string;

  readonly maxBadLoginAttempts = 5;
  readonly enumUserStatus = EnumUserStatus;
  readonly enumLoginStatus = EnumLoginStatus;

  get userStatusValue(): number | undefined {
    return getEnumValue(this.badLogInAttempt().userStatus, EnumUserStatus);
  }

  get loginStatusValue(): number | undefined {
    return getEnumValue(this.badLogInAttempt().loginStatus, EnumLoginStatus);
  }

  constructor() {
    localStorage.removeItem('lastSsoProvider');
    localStorage.removeItem('challengeUrl');

    const urlParams = new URLSearchParams(window.location.search);
    this.ssoClientName = urlParams.get('client') ?? '';
    this.ssoClientName = this.ssoClientName[0]?.toUpperCase() + this.ssoClientName.slice(1);
  }
}
